import './accordions.scss';
import $ from 'jquery';

$(function(){

    //Au chargement de la page
    $('.collapse').each(function(){
        if($(this).hasClass('show')){
            var header = $(this).prev('div');
            header.addClass('expanded');
        }
    });

    //au SHOW d'un collapse
    $('.collapse').on('show.bs.collapse', function(){
        var header = $(this).prev('div');
        header.addClass('expanded');
    });

    //au HIDE d'un collapse
    $('.collapse').on('hide.bs.collapse', function(){
        var header = $(this).prev('div');
        header.removeClass('expanded');
    });

    //Ouvrir un collpase si il est dans l'URL
    if($('#accordion').length){
        if(window.location.href.indexOf("#") > -1) {
            var panel = window.location.href.substr(window.location.href.indexOf("#")+1);
            var header = $('#'+panel);
            if(header.length) {
                $('.collapse').each(function () {
                    $(this).collapse('hide');
                });
                header.addClass('expanded');
                header.next('div').addClass('show');
            }
        }
    }

});